// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2Qvqm","left":"InfoRow_left__39wPC"};